module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"lt":{"title":"Mokėjimo būdai","data":{"payu":"PayU","montonio":"Montonio","blik":"BLIK","creditCard":"Mokėjimo kortelė"}},"en":{"title":"Payment Methods","data":{"payu":"PayU","montonio":"Montonio","blik":"BLIK","creditCard":"Payment Card"}}}')
  delete Component.options._Ctor
}
